var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"placement":_vm.placement,"content":_vm.content,"popper-class":"help-tip__popper"}},[_c('i',{staticClass:"fa fa-info-circle text-muted help-tip__icon",attrs:{"role":"img","tabindex":"0","aria-label":_vm.content}})])
}
var staticRenderFns = []

export { render, staticRenderFns }